module.exports = __webpack_public_path__ + "static/media/Gyanmanjari.2f864031.jpg";